import React from 'react';
import PropTypes from 'prop-types';
import redraft from 'redraft';
import { flattenToAppURL } from '@plone/volto/helpers';
import { LinkMore } from '@plone/volto/components';
import config from '@plone/volto/registry';


const View = ({ data }) => (
  <div className="block hero">
    <div className="block-inner-wrapper">
      {data.url && (
        <img
          src={`${flattenToAppURL(data.url)}/@@images/image`}
          alt=""
          className="hero-image"
          loading="lazy"
          srcSet={flattenToAppURL(data.url) + "/@@images/image/preview 400w, " + flattenToAppURL(data.url) + "/@@images/image/preview 800w, " + flattenToAppURL(data.url) + "/@@images/image/tablet 1024w, " + flattenToAppURL(data.url) + "/@@images/image/huge 1600w, " + flattenToAppURL(data.url) + "/@@images/image/great 1200w, " + flattenToAppURL(data.url) + "/@@images/image/mini 200w"}
          sizes="80vw"
        />
      )}
      <div className="hero-body">
        <div className="hero-text">
          {data.title && <h1>{data.title}</h1>}
          {data.description &&  (
            <p>
              {redraft(
                data.description,
                config.settings.richtextViewSettings.ToHTMLRenderers,
                config.settings.richtextViewSettings.ToHTMLOptions,
              )}
            </p>
          )}
        </div>
        <LinkMore data={data} />
      </div>
    </div>
  </div>
);

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default View;
